import { getStoredAuthToken } from '../../lib/authStorage';

export const SPORTSNEW_AUTH_SESSION_STALE_CODE = 'SPORTSNEW_AUTH_SESSION_STALE';

const bearerToken = value => String(value || '').trim().replace(/^Bearer\s+/i, '');

// The caller owns account generations. This is only an immutable transport
// snapshot; it creates no auth state, storage key, timer, or session listener.
export const captureSportsnewAccountCarrier = ({ accountGuard, isCurrent } = {}) => {
  const carrier = {
    userId: Number(accountGuard?.userId),
    generation: Number(accountGuard?.generation),
    accountKey: String(accountGuard?.accountKey || ''),
  };
  // Credentials and live functions must not enter an attempt JSON record.
  Object.defineProperties(carrier, {
    token: { value: bearerToken(getStoredAuthToken()) },
    isCurrent: { value: isCurrent },
  });
  return Object.freeze(carrier);
};

export const isSportsnewAccountCarrierCurrent = carrier => {
  try {
    return Number.isSafeInteger(carrier?.userId) && carrier.userId > 0
      && Number.isSafeInteger(carrier?.generation) && carrier.generation >= 0
      && carrier.accountKey === `${carrier.userId}:${carrier.generation}`
      && Boolean(carrier.token)
      && carrier.token === bearerToken(getStoredAuthToken())
      && typeof carrier.isCurrent === 'function'
      && carrier.isCurrent() === true;
  } catch {
    return false;
  }
};

export const sportsnewLocalRequestRejection = (code = SPORTSNEW_AUTH_SESSION_STALE_CODE) => {
  const message = 'Sports request changed before dispatch';
  return Object.assign(new Error(message), {
    code,
    response: {
      status: 409,
      headers: {},
      data: { status: false, code, message, localRequestRejected: true },
    },
  });
};
